export default "__VITE_ASSET__BLI8Hzhd__"